export enum ConfirmationModalTypes {
	Confirm = 'confirm',
	Cancel = 'cancel',
}

export enum ModalActions {
	Submit,
	Cancel,
}
